/**
 * WARNING: This file is auto-generated. Please do not modify it.
 *
 * If you need to make changes, please see the README.md file in the root of this repository.
 */

import { AxiosRequestConfig, AxiosResponse } from 'axios';

import { Controller } from '../Controller';

import {
  GetV2ProjectsPrototypesReportConfigByProjectIdAndPrototypeIdParams,
  PutV2ProjectsPrototypesReportConfigByProjectIdAndPrototypeIdParams,
  DeleteV2ProjectsPrototypesReportConfigByProjectIdAndPrototypeIdParams,
  PutV2ProjectsPrototypesReportConfigByProjectIdAndPrototypeIdBody,
  GetV2ProjectsPrototypesReportConfigByProjectIdAndPrototypeIdResponse,
  PutV2ProjectsPrototypesReportConfigByProjectIdAndPrototypeIdResponse,
} from '../types';

export class PrototypeReportMetricConfig extends Controller {
  async getV2ProjectsPrototypesReportConfigByProjectIdAndPrototypeId<
    T extends GetV2ProjectsPrototypesReportConfigByProjectIdAndPrototypeIdResponse,
    D,
    C
  >(
    {
      projectId,
      prototypeId,
    }: GetV2ProjectsPrototypesReportConfigByProjectIdAndPrototypeIdParams,
    axiosConfig?: AxiosRequestConfig<C> | undefined
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.get<T, AxiosResponse<T, D>, C>(
      `/v2/projects/${projectId}/prototypes/${prototypeId}/report-config`,
      axiosConfig
    );
  }

  async putV2ProjectsPrototypesReportConfigByProjectIdAndPrototypeId<
    T extends PutV2ProjectsPrototypesReportConfigByProjectIdAndPrototypeIdResponse,
    D,
    C extends PutV2ProjectsPrototypesReportConfigByProjectIdAndPrototypeIdBody
  >(
    body: C,
    {
      projectId,
      prototypeId,
    }: PutV2ProjectsPrototypesReportConfigByProjectIdAndPrototypeIdParams,
    axiosConfig?: AxiosRequestConfig<C> | undefined
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.put<T, AxiosResponse<T, D>, C>(
      `/v2/projects/${projectId}/prototypes/${prototypeId}/report-config`,
      body,
      axiosConfig
    );
  }

  async deleteV2ProjectsPrototypesReportConfigByProjectIdAndPrototypeId<
    T,
    D,
    C extends null
  >(
    {
      projectId,
      prototypeId,
    }: DeleteV2ProjectsPrototypesReportConfigByProjectIdAndPrototypeIdParams,
    axiosConfig?: AxiosRequestConfig<C> | undefined,
    body?: C
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.delete<T, AxiosResponse<T, D>, C>(
      `/v2/projects/${projectId}/prototypes/${prototypeId}/report-config`,
      { ...axiosConfig, data: body }
    );
  }
}
